import {computed} from '@vue/composition-api';
import {getTripContext, getTripId} from '@/store/state/helpers';

export type NavItem = {
  name: string;
  route: string;
};

export const buildNavItems = (tripId: string, context: string): NavItem[] => {
  return [
    {name: 'Home', route: '/discovery'},
    {name: `Explore `, route: `/explore/${tripId}/${context}`},
    {name: 'Summary', route: `/summary/${tripId}/${context}`},
    // {name: 'Your Trip', route: '/my-trips'},
    // {name: 'Profile', route: '/profile'},
  ];
};

export const computedNavItems = computed(() => {
  const tripId = getTripId();
  // if we already have solution - show Explore & Summary nav links
  if (tripId) {
    return buildNavItems(tripId, getTripContext());
  } else {
    // if no solution - show just home nav
    return [{name: 'Home', route: '/discovery'}];
  }
});
